import React, { SyntheticEvent, useRef } from "react";
import { Button } from "react-bootstrap";
import { FileStatus } from "../../type/FileStatusType";
import Utility from "../../utility/Utility";
import { StateAdminCSVHeader, AshaCSVHeader } from "../../constants/csv";
import { Trans } from "react-i18next";

enum ErrorButtonActionType {
  SELECTFILE = "SELECTFILE",
  DOWNLOAD = "DOWNLOAD",
  CANCEL = "CANCEL",
}

interface UploadCSVErrorType {
  errorData: any;
  setFileStatus: (filename: FileStatus) => void;
  handelFileUpload: (fileInfo: File[]) => void;
  errorList: any;
  addType: any;
}

const UploadCSVError = ({
  errorData,
  setFileStatus,
  handelFileUpload,
  errorList,
  addType,
}: UploadCSVErrorType) => {
  const fileInput = useRef<HTMLInputElement>(null);

  //Function to render primary button text value

  const renderActionTextValue = (actionValue: ErrorButtonActionType) => {
    switch (actionValue) {
      case ErrorButtonActionType.SELECTFILE:
        return "select_file";
      case ErrorButtonActionType.DOWNLOAD:
        return "download";
    }
  };

  const handleFileInputChange = (event: SyntheticEvent<EventTarget>) => {
    event.preventDefault();
    event.stopPropagation();
    const fileUploaded = (event.target as HTMLFormElement).files;
    handelFileUpload([...fileUploaded]);
  };

  //Primary Button Click action based on actions
  const onActionClick = (actionValue: ErrorButtonActionType) => {
    switch (actionValue) {
      case ErrorButtonActionType.SELECTFILE:
        fileInput?.current?.click();
        return;
      case ErrorButtonActionType.CANCEL:
        setFileStatus(FileStatus.INIT);
        return;
      case ErrorButtonActionType.DOWNLOAD:
        let headers;
        let fileName;
        if (addType === "admin") {
          headers = StateAdminCSVHeader;
          fileName = "StateAdminErrorList";
        } else if (addType === "asha") {
          headers = AshaCSVHeader;
          fileName = "AshaErrorList";
        }
        Utility.exportCSVFile(headers, errorList, fileName);
        return;
      default:
        return;
    }
  };

  return (
    <div>
      <input
        type="file"
        name="file"
        hidden
        onChange={handleFileInputChange}
        accept=".csv,text/csv"
        ref={fileInput}
      />
      <div className="errorTitle" data-testid="errorDataTitle">
        {errorData?.title_key ? (
          <>
            <Trans i18nKey={errorData?.title_key} />
            {errorData?.entryDetailsFailed
              ? ` ${errorData?.jsonDataLength}/${errorData?.bulkJobDetails} `
              : ""}
            {errorData?.entryDetailsFailed ? (
              <Trans i18nKey={errorData?.entryDetailsFailed} />
            ) : (
              ""
            )}
          </>
        ) : (
          errorData.title
        )}
      </div>
      <div className="errorMessage" data-testid="errorDataMessage">
        {errorData?.message_key ? (
          <Trans i18nKey={errorData?.message_key} />
        ) : (
          errorData.message
        )}
      </div>
      <div className="errorButtonContainer">
        <Button
          variant="outline"
          className="errorUploadButton"
          onClick={() => onActionClick(ErrorButtonActionType.CANCEL)}
        >
          <Trans i18nKey={"cancel"} />
        </Button>
        <Button
          className="selectButton"
          data-testid="errorActionButton"
          onClick={() => onActionClick(errorData.actionButtonType)}
        >
          <Trans i18nKey={renderActionTextValue(errorData.actionButtonType)} />
        </Button>{" "}
      </div>
    </div>
  );
};

export default UploadCSVError;
